import type { SelectedFile } from 'components/DynamicDownload/interfaces';

export const dynamicDownloads: SelectedFile[] = [
  {
    id: 1,
    name: 'Detalle_transaccion_747_20231128_110439.xlsx',
    type: 'xlsx',
    status: 'downloading',
    url: '#',
  },
  {
    id: 2,
    name: 'Detalle_transaccion_746_20231128_110439.xlsx',
    type: 'xlsx',
    status: 'downloaded',
    url: '#',
  },
  {
    id: 3,
    name: 'Errores_de_cargadores_20231128_122303.xlsx',
    type: 'xlsx',
    status: 'error',
    url: '#',
  },
];
